export default "__VITE_ASSET__K_$3CD7Y__"